import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { Icons } from "src/libs/assets";
import { CountryStore, FilterStore } from "src/stores";
import { Button, Checkbox, P } from "..";
import { tx } from "src/libs/i18n";
import * as s from "./CountrySearchDropdown.module.scss";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  inputPlaceholder?: string;
  countryStore?: CountryStore;
  filterStore?: FilterStore;
}

@inject("filterStore", "countryStore")
@observer
export class CountrySearchDropdown extends Component<Props> {
  private inputRef;

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  focusInput = () => {
    this.inputRef.current.focus();
  };

  renderOption = (item, key) => {
    const { toggleCountry } = this.props.countryStore;
    const { value, selected } = item;
    return (
      <div className={s.dropdownItem} key={key} onClick={() => toggleCountry(item)}>
        <Checkbox type="check" onChange={() => toggleCountry(item)} selected={selected} />
        <P className={s.dropdownItemLabel}>{value}</P>
      </div>
    );
  };

  render() {
    const {
      inputPlaceholder,
      countryStore,
      style,
      className,
      children,
      filterStore,
      ...rest
    } = this.props;

    const { searching, searchResults, searchCountries, toggleOverlay } = countryStore;
    const { countries } = filterStore;

    let countrydropdownContainerClasses = [s.countrydropdownContainer];

    if (className) countrydropdownContainerClasses.push(className);
    return (
      <div className={countrydropdownContainerClasses.join(" ")} style={style} {...rest}>
        <div className={s.inputContainer}>
          <img
            src={Icons.search_small}
            alt="dropdown-icon"
            className={s.inputIcon}
            onClick={this.focusInput}
          />
          <input
            type="text"
            className={s.inputField}
            placeholder={inputPlaceholder}
            ref={this.inputRef}
            onInput={searchCountries}
          />
        </div>
        <div className={s.countryDropdown}>
          {searching && searchResults && searchResults.map(this.renderOption)}
          {!searching && countries && countries.map(this.renderOption)}
          {searching && searchResults.length === 0 && (
            <div className={s.noResultsItem}>{tx("search.noResultsFound")}</div>
          )}
        </div>
        <div className={s.buttonContainer}>
          <Button
            size="medium"
            color="red"
            className={s.searchQueryButton}
            onClick={toggleOverlay}
          >
            {tx("search.addToQuery")}
          </Button>
        </div>
      </div>
    );
  }
}
